import React, { useState } from 'react'
import { Col, Drawer, Layout, Menu, Row, Space } from 'antd';
import { SideItem } from '../../components';
import { menus } from '../../utils';
import { Link } from 'react-router-dom';
import Logo from '../../assets/logo.svg'
import { MenuOutlined } from '@ant-design/icons';
import { useEffect } from 'react';

const Sidebar = ({ open, close }) => {

    const { Sider } = Layout;
    return (
        <Row>
            <Col xs={{ span: 0 }} xl={{ span: 24 }}>
                <Sider className='sidebar'
                // <Sider className={active === true ? 'sidebar active' : 'sidebar'}

                >
                    <div className='menu_icon side_icon' onClick={close}>

                        <MenuOutlined style={{ fontSize: 22 }} />
                    </div>
                    <Space style={{ height: "80px", display: "flex", margin: "25px 0px", alignItems: 'center', justifyContent: 'center' }} >
                        <Link to="/">
                            <img src={Logo} style={{ width: 158, height: 48 }} alt="" />
                        </Link>
                    </Space>

                    <ul>
                        {menus.map((v, i) => (
                            <li key={i} style={{ position: "relative" }}>
                                <SideItem title={v.title} children={v.children} path={v.path} />
                            </li>
                        ))}
                    </ul>
                </Sider>
            </Col>
            <Col xs={{ span: 24 }} xl={{ span: 0 }}>
                <Drawer
                    // title="Basic Drawer"
                    placement="left"
                    onClose={close}
                    open={open}
                    closable={false}
                    // title={false}
                    maskStyle={{ background: 'transparent' }}
                    bodyStyle={{ padding: 0, width: 'fit-content' }}
                    width='fit-content'
                >
                    <Sider className='sidebar'
                    // <Sider className={active === true ? 'sidebar active' : 'sidebar'}

                    >
                        <div className='menu_icon side_icon' onClick={close}>

                            <MenuOutlined style={{ fontSize: 22 }} />
                        </div>
                        <Space style={{ height: "80px", display: "flex", margin: "25px 0px", alignItems: 'center', justifyContent: 'center' }} >
                            <Link to="/">
                                <img src={Logo} style={{ width: 158, height: 48 }} alt="" />
                            </Link>
                        </Space>

                        <ul>
                            {menus.map((v, i) => (
                                <li key={i} style={{ position: "relative" }}>
                                    <SideItem title={v.title} children={v.children} path={v.path} />
                                </li>
                            ))}
                        </ul>
                    </Sider>
                </Drawer>
            </Col>


        </Row>

    )
}

export default Sidebar